import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGlobe, FiTablet, FiBookOpen, FiBook, FiArrowUpRight } = FiIcons;

const purchaseLinks = [
  { name: 'Author Website', desc: 'Direct from Andrei', url: 'https://ciomirtan.com/book/how-to-love-a-good-man-the-8-essential-truths-of-the-male-heart/', icon: FiGlobe, highlight: true },
  { name: 'Kindle', desc: 'Instant digital download', url: 'https://www.amazon.com/dp/B0GTJRLQV9', icon: FiTablet, highlight: false },
  { name: 'Paperback', desc: 'Classic physical copy', url: 'https://www.amazon.com/dp/B0GTJHV5BB', icon: FiBookOpen, highlight: false },
  { name: 'Hardcover', desc: 'Premium edition', url: 'https://www.amazon.com/dp/B0GTLZFXQR', icon: FiBook, highlight: false },
];

const BuyButtons = () => (
  <div id="buy" className="grid sm:grid-cols-2 gap-4 w-full max-w-2xl mx-auto">
    {purchaseLinks.map((link) => (
      <a
        key={link.url}
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className={`group flex items-center p-5 rounded-2xl border-2 transition-all duration-300 ${
          link.highlight
            ? 'border-brand-accent bg-brand-accent/5 hover:bg-brand-accent'
            : 'border-slate-200 bg-white hover:border-brand-dark hover:shadow-lg'
        }`}
      >
        <div className={`w-11 h-11 rounded-full flex items-center justify-center mr-4 flex-shrink-0 transition-colors ${
          link.highlight ? 'bg-brand-accent text-white group-hover:bg-white group-hover:text-brand-accent' : 'bg-slate-100 text-slate-600 group-hover:bg-brand-dark group-hover:text-white'
        }`}>
          <SafeIcon icon={link.icon} className="text-lg" />
        </div>
        <div className="text-left">
          <div className={`font-bold ${link.highlight ? 'text-brand-dark group-hover:text-white' : 'text-brand-dark'}`}>{link.name}</div>
          <div className={`text-xs ${link.highlight ? 'text-slate-600 group-hover:text-white/80' : 'text-slate-500'}`}>{link.desc}</div>
        </div>
        <FiArrowUpRight className={`ml-auto text-lg opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 ${link.highlight ? 'text-white' : 'text-brand-dark'}`} />
      </a>
    ))}
  </div>
);

export default BuyButtons;